<div *ngIf="allSubcontractors && selectedSubconstractors" class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text" i18n="@@main.calendar.subcontractors.title">Podizvajalci</h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
                <li class="m-portlet__nav-item">
                    <div (click)="openAvailabilityReportPopup()" class="m-portlet__nav-link m-portlet__nav-link--icon mf-collapse-button">
                        <i class="la la-list"></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <cal-subs-list
        *ngIf="allSubcontractors"
        [allSubcontractors]="allSubcontractors"
        [selectedSubconstractors]="selectedSubconstractors"
        (onChangeSelect)="reloadEventsPublic($event)"
        (changeSubcontractorFilter)="reloadEventsPublic($event)"
    ></cal-subs-list>
</div>
